import { createContext } from 'react';
import { GetAccountsCashflowsParams } from '@goldwasserexchange/actor/rest-services';

export const accountsCashflowsParamsContext = createContext<Partial<GetAccountsCashflowsParams>>({});
